import React from 'react';
import { Container, Grid } from 'semantic-ui-react';
import { SignupForm } from '../../components/index';
import { connect } from '../../../utils/connect';

const SignupPage = () => (
  <Container>
    <Grid>
      <Grid.Row>
        <SignupForm register={connect.register} />
      </Grid.Row>
    </Grid>
  </Container>
);

export default SignupPage;



// WEBPACK FOOTER //
// ./src/views/pages/SignupPage/SignupPage.js